// src/applicationInsights.ts
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();

const connectionString =
  process.env.REACT_APP_INSIGHTS_CONNECTION_STRING;

let appInsights = null;

if (connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,

      // Tracks route changes in single-page apps
      enableAutoRouteTracking: true,

      // Helps correlate browser calls to your backend API
      enableCorsCorrelation: true,

      // Connects the React plugin to the core App Insights SDK
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: {}
      }
    }
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags || {};

    // Explicitly stamps frontend browser telemetry as:
    // cloud_RoleName = React-Client
    envelope.tags["ai.cloud.role"] = "React-Client";

    // Optional: helps identify which host/browser source sent telemetry
    envelope.tags["ai.cloud.roleInstance"] = window.location.hostname;
  });

  appInsights.trackPageView();
} else {
  console.warn(
    "App Insights disabled: no connection string configured for this environment."
  );
}

export { reactPlugin };
export default appInsights;